import { faChevronRight, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect, useRef } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import AdjustPositionDropdown from '../AdjustPositionDropdown';
import ProductGallery from '../ProductsAndStyle/ProductGallery';
import StyleGallery from '../ProductsAndStyle/StyleGallery';
import CreativeControl from './CreativeControl';
import ProductDropdown from './ProductDropdown';
import { uploadToS3 } from '../../../config/aws';
import { USER_NAME } from '../../../constant';
import html2canvas from 'html2canvas';
import { sendToBackend } from '../../../utils/utilities';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { checkAvailableCredits, decreaseCredits } from '../../../dbApiFunctions';
import { showSuccessAlert, showErrorAlert, showWarningAlert, showInfoAlert, showConfirmDialog } from '../../../utils/sweetAlertConfig';
import '../../../styles/sweetAlert.css';
import { repharsePrompt } from '../../../services/chatgptService';
import { fal } from "@fal-ai/client";
import { useImage } from '../../../context/ImageContext';

// Configure fal.ai client with credentials
fal.config({
  credentials: process.env.REACT_APP_FAL_AI_KEY
});

const CreateSidebar = ({ selectedProduct, setSelectedProduct, createEstTime, setCreateEstTime, setJobResponseCreate, progressCreate, setCreditsAvailable, value, setValue, selectedStyle, setSelectedStyle, prompt, setPrompt, loadingCircle, setLoadingCircle, containerRef, imageRef, refNum, randomize, numberOfImages, setRefNum, setRandomize, setNumberOfImages, maxstyle, setMaxstyle, adjustDropdownIsOpen, setAdjustDropdownIsOpen, options }) => {

  const [showRandomizeInfo, setShowRandomizeInfo] = useState(false);
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [isStyleModalOpen, setIsStyleModalOpen] = useState(false);
  const [showStyleInfo, setShowStyleInfo] = useState(false);
  const [isRephrasing, setIsRephrasing] = useState(false);
  const { activeTab } = useImage();
  const allAspectRatio = [1/1, 16/9, 4/3, 3/4, 9/16];
  const [aspectRatio, setAspectRatio] = useState(allAspectRatio[0]);

  const s3_sub_folder = activeTab === 'bgh' ? "all_bghPage" : "all_createPage";

  useEffect(() => {
    document.body.style.overflow = (isProductModalOpen || isStyleModalOpen) ? 'hidden' : '';
  }, [isProductModalOpen, isStyleModalOpen]);

  const handleStyleSelect = (style) => {
    setSelectedStyle(style);
  };

  const handleProductSelect = (product) => {
    setSelectedProduct(product);
  };

  const createGeminiImage = async (imageUrl, timestamp, index) => {

    const result = await fal.subscribe("fal-ai/flux-pro/kontext/max", {
      input: {
        prompt: prompt,
        image_url: imageUrl
      }
    });
    // console.log(result.data);
    const upscaledUrl = result.data.images[0].url;

    if (!upscaledUrl) {
      throw new Error("No image URL in response from upscaler");
    } else {
      // Fetch the image data from the URL
      const response = await fetch(upscaledUrl);
      const imageBlob = await response.blob();

      // Upload both low and high quality versions
      await uploadToS3(`USERS/${USER_NAME}/${s3_sub_folder}/${timestamp}/outputFolder/lowQuality/${index}.png`, 'image/png', imageBlob);
      await uploadToS3(`USERS/${USER_NAME}/${s3_sub_folder}/${timestamp}/outputFolder/highQuality/${index}.png`, 'image/png', imageBlob);
    }
  }




  const handleGenerate = async () => {
    setLoadingCircle(true);
    // Validate inputs before generation
    if (!selectedProduct || selectedProduct.name === "Select a Product Image") {
      showErrorAlert('Please select a product image before generating', 'Product Required');
      return;
    }
    // if (!selectedStyle || selectedStyle.name === "Select a Style") {
    //   alert("Please Select a Style before generating");
    //   return;
    // }

    if (!prompt.trim()) {

      showErrorAlert('Please enter a prompt description', 'Prompt Required');
      return;
    }

    // setCreateEstTime(120);

    const timestamp = new Date().getTime();
    let formJson = {
      productName: selectedProduct.name,
      prompt: prompt,
      totalImages: numberOfImages,
      style: selectedStyle.name === "Select a Style" ? null : selectedStyle.name,
      creativeControl: options[value].label,
      creativeControlValue: value,
      userName: USER_NAME,
      timestamp: timestamp,
      time: new Date().toLocaleString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        month: 'short',
        day: 'numeric',
        hour12: false
      }),
      refNum: refNum,
      maxstyle: maxstyle
    };
    if (value !== 2 && containerRef.current && imageRef.current) {
      // Capture the current position and scale from the AdjustPositionDropdown
      const position = imageRef.current.style.transform;
      // Extract position values using regex
      const translateMatch = position.match(/translate\(([^,]+)px,\s*([^)]+)px\)/);
      const scaleMatch = position.match(/scale\(([^)]+)\)/);
      const dropdownContent = document.querySelector('#dropdown-content');
      formJson['x'] = translateMatch ? parseFloat(translateMatch[1]) : 0;
      formJson['y'] = translateMatch ? -1 * parseFloat(translateMatch[2]) : 0;
      formJson['scale'] = scaleMatch ? parseFloat(scaleMatch[1]) : 1;
      formJson['canvasWidth'] = dropdownContent.offsetWidth;
      formJson['canvasHeight'] = dropdownContent.offsetHeight;
      formJson['randomize'] = randomize;
      formJson['aspectRatio'] = aspectRatio;
    }
    await uploadToS3(`USERS/${USER_NAME}/${s3_sub_folder}/${timestamp}/metadata.json`, 'application/json', JSON.stringify(formJson));
    try {
      let response = {}
      const backendPromises = [];
      // Loop value times to simulate multiple image generation
      // setCreateEstTime(120);
      // for (let i = 0; i < numberOfImages-1; i++) {
      //   formJson['pid'] = i;
      //   response = sendToBackend('create', formJson, numberOfImages);
      // }
      const password = sessionStorage.getItem("password");
      const email = sessionStorage.getItem("email");
      const creditsAvailable = await checkAvailableCredits(email, password, numberOfImages);
      if (!creditsAvailable.status) {
        showErrorAlert(creditsAvailable.message, 'Insufficient Credits');
        return;
      }

      if (formJson.creativeControl === 'Moderate' && activeTab === 'bgh') {
        formJson['prompt'] = "OUTPAINT ONLY — do not move, resize, rotate or flip the product. Keep the product in the exact same position, angle and silhouette. Extend the background to Generate " + formJson.prompt;

        // try {
        //   fetch("https://zdaee2kdn0.execute-api.us-east-1.amazonaws.com/shutterlabBackend", {
        //     method: 'POST',
        //     headers: {
        //       'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify(formJson)
        //   })
        //     .then(res => res.json())
        //     .then(data => // console.log("---------->", data))
        //     .catch(err => console.error(err));
        // } catch (error) {
        //   console.error("Error generating images:", error);
        //   showErrorAlert("Failed to generate images with Mode 2. Please try again.");
        //   return;
        // }
      }

      if (formJson.creativeControl === 'Mode 2' && activeTab === 'create') {
        // console.log("Mode 2 is selected calling context api");
        try {
          const geminiPromises = [];
          for (let i = 0; i < numberOfImages; i++) {
            geminiPromises.push(createGeminiImage(selectedProduct.src, timestamp, i));
          }
          await Promise.all(geminiPromises);
          await decreaseCredits(email, password, numberOfImages, "create");
        } catch (error) {
          console.error("Error generating images:", error);
          showErrorAlert("Failed to generate images. Please try again.");
          return;
        }
      }
      else {
        if (numberOfImages > 1) {
          const metadata2 = structuredClone(formJson);
          metadata2['pid'] = numberOfImages - 2;
          backendPromises.push(sendToBackend('create', metadata2, 0, setCreditsAvailable));
        }

        if (numberOfImages > 2) {
          const metadata3 = structuredClone(formJson);
          metadata3['pid'] = numberOfImages - 3;
          backendPromises.push(sendToBackend('create', metadata3, 0, setCreditsAvailable));
        }

        if (numberOfImages > 3) {
          const metadata4 = structuredClone(formJson);
          metadata4['pid'] = numberOfImages - 4;
          backendPromises.push(sendToBackend('create', metadata4, 0, setCreditsAvailable));
        }

        formJson['pid'] = numberOfImages - 1;
        backendPromises.push(sendToBackend('create', formJson, numberOfImages, setCreditsAvailable));

        // Wait for all backend calls to complete
        const responses = await Promise.all(backendPromises);
        response = responses[responses.length - 1]; // Get the last response

        // console.log("Create response is=", response);
        setJobResponseCreate(response);
        // setCreateEstTime(response.est_time);
        if (response && response.hasOwnProperty('est_time')) {
          // console.log("Create waiting time is=", response.est_time);
        } else {
          // console.log("Create waiting time is not available");
        }
      }
    } catch (error) {
      console.error("Error in handleGenerate:", error);
      showErrorAlert("Failed to generate images. Please try again.");
    } finally {
      setCreateEstTime(1);
      setLoadingCircle(false);
    }
    setLoadingCircle(false);
  };

  return (
    <>
      <div className={`fixed inset-0 backdrop-blur-lg transition-all duration-500 ${(isProductModalOpen || isStyleModalOpen) ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}></div>
      <div className={`relative ${(isProductModalOpen || isStyleModalOpen) ? 'blur-lg' : ''}`}>
        <div className="fixed top-0 left-0 h-screen w-full lg:w-1/4 bg-white flex flex-col">
          <div className="p-4 lg:p-6 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800">Create and Edit</h2>
          </div>
          <div
            className="flex-1 overflow-y-auto p-4 lg:p-6"
            onMouseEnter={(e) => {
              document.body.style.overflow = 'hidden';
            }}
            onMouseLeave={(e) => {
              document.body.style.overflow = '';
            }}
          >
            <div className="mt-12 mb-8">
              <ProductDropdown selectedProduct={selectedProduct} setIsProductModalOpen={setIsProductModalOpen} setSelectedProduct={setSelectedProduct} setAdjustDropdownIsOpen={setAdjustDropdownIsOpen} />
            </div>

            <CreativeControl value={value} setValue={setValue} options={options} />

            <div className="mb-8">
              {activeTab !== 'create' && <AdjustPositionDropdown containerRef={containerRef} imageRef={imageRef} isOpen={adjustDropdownIsOpen} setIsOpen={setAdjustDropdownIsOpen} aspectRatio={aspectRatio} />}
            </div>

            <div className="mb-8">
              <div className="flex items-center gap-2 mb-3">
                <label className="block text-gray-700 font-semibold text-sm tracking-wide">Style</label>
                <button
                  onClick={() => setShowStyleInfo(!showStyleInfo)}
                  className="text-gray-400 hover:text-purple-500 transition-all duration-300 transform hover:scale-110"
                >
                  <FaInfoCircle size={16} />
                </button>
              </div>
              {showStyleInfo && (
                <div className="mb-4 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 border-l-4 border-purple-500 rounded-md shadow-md w-full transition-all duration-200">
                  <div className="flex items-start space-x-3">
                    <i className="fas fa-lightbulb text-purple-500 mt-0.5"></i>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      Style defines the overall theme of the generated scene
                    </p>
                  </div>
                </div>
              )}
              <div
                className="flex items-center justify-between p-2  border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer group relative overflow-hidden bg-white"
                onClick={() => setIsStyleModalOpen(true)}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-[#4B3BFF] to-[#7B6BFF] opacity-0 group-hover:opacity-5 transition-all duration-300"></div>
                <div className="flex items-center space-x-4 relative">
                  <img
                    alt={selectedStyle.name}
                    className="w-12 h-12 rounded-lg group-hover:scale-110 transition-transform duration-300 object-cover"
                    height="50"
                    src={selectedStyle.src}
                    width="50"
                  />
                  <span className="text-gray-800 font-medium group-hover:text-[#4B3BFF] transition-colors duration-300">{selectedStyle.name}</span>
                </div>
                <div className="flex items-center relative z-10" >
                  {selectedStyle.name !== "Select a Style" && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedStyle({ "src": "https://img.icons8.com/?size=100&id=106359&format=png&color=000000", "name": "Select a Style" });
                      }}
                      className="mr-2 text-gray-400 hover:text-red-500 transition-all duration-300 relative z-20"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                      </svg>
                    </button>
                  )}
                  <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 group-hover:text-[#4B3BFF] group-hover:translate-x-1 transition-all duration-300 relative z-10" />
                </div>
              </div>

              {selectedStyle.name !== "Select a Style" && activeTab !== 'create' && (
                <label
                  htmlFor="maxstyle"
                  className="mt-3 flex items-center gap-2.5 py-2 px-3 rounded-lg hover:bg-gray-50 transition-all duration-300 cursor-pointer group border border-gray-100"
                >
                  <input
                    type="checkbox"
                    id="maxstyle"
                    className="w-4 h-4 text-[#4B3BFF] border-gray-200 rounded focus:ring-[#4B3BFF] focus:ring-2 focus:ring-offset-0 cursor-pointer"
                    checked={maxstyle}
                    onChange={(e) => setMaxstyle(e.target.checked)}
                  />
                  <span className="text-sm font-medium text-gray-600 group-hover:text-[#4B3BFF] transition-colors duration-300">
                    Max Style
                  </span>
                </label>
              )}
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 font-semibold mb-3 text-sm tracking-wide">Prompt</label>
              <div className="relative">
                <textarea
                  className="w-full p-4 border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 bg-white focus:outline-none focus:ring-2 focus:ring-[#4B3BFF] focus:border-transparent"
                  placeholder="Create a stunning product image featuring a sleek smartwatch, illuminated by soft, ambient lighting that highlights its modern design and vibrant display."
                  rows="4"
                  value={prompt}
                  onChange={(e) => setPrompt(e.target.value)}
                ></textarea>
                <div className="absolute bottom-4 right-4 flex gap-2">
                  <button
                    onClick={() => repharsePrompt(prompt, setPrompt, setIsRephrasing)}
                    disabled={isRephrasing}
                    className={`p-2 rounded-lg transition-all duration-300 ${isRephrasing
                      ? 'bg-gray-200 cursor-not-allowed'
                      : 'bg-purple-100 hover:bg-purple-200'
                      }`}
                    title="Rephrase prompt"
                  >
                    <FontAwesomeIcon
                      icon={faWandMagicSparkles}
                      className={`text-purple-600 ${isRephrasing ? 'animate-spin' : ''}`}
                    />
                  </button>
                </div>
              </div>
            </div>
            {/*             
            <div className="mb-4">
             
              <div className="flex items-center justify-between p-4 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 bg-white border border-gray-100 group relative overflow-hidden"
                onClick={() => setRandomize(!randomize)}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-[#4B3BFF] to-[#7B6BFF] opacity-0 group-hover:opacity-5 transition-all duration-300"></div>
                <label
                  htmlFor="randomize"
                  className="text-sm font-medium text-gray-700 cursor-pointer group-hover:text-[#4B3BFF] transition-colors duration-300 flex items-center"
                >
                  <span className="font-semibold">Diversify</span>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowRandomizeInfo(!showRandomizeInfo);
                    }}
                    className="text-gray-400 hover:text-[#4B3BFF] transition-all duration-300 transform hover:scale-110 ml-2"
                  >
                    <FaInfoCircle size={16} />
                  </button>
                </label>
                <input
                  type="checkbox"
                  id="randomize"
                  className="w-5 h-5 text-[#4B3BFF] border-gray-300 rounded focus:ring-[#4B3BFF] focus:ring-2 cursor-pointer"
                  checked={randomize}
                />
              </div>
              {showRandomizeInfo && (
                <div className="mb-4 mt-4 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 border-l-4 border-purple-500 rounded-md shadow-md w-full transition-all duration-200">
                  <div className="flex items-start space-x-3">
                    <i className="fas fa-lightbulb text-purple-500 mt-0.5"></i>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      Without "Diversify", you'll get the very similar images each time. Turn it on for new variations.
                    </p>
                  </div>
                </div>
              )}
            </div> 
*/}


          </div>



          <div className="bg-white p-4 lg:p-6 border-t border-gray-200 shadow-sm">
            <div className="flex items-center gap-3">
              <div className="flex flex-col mr-2">
                <div className="flex items-center border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 bg-white hover:border-[#4B3BFF] overflow-hidden h-10">
                  <button
                    onClick={() => setNumberOfImages(Math.max(1, parseInt(numberOfImages) - 1))}
                    className="px-1 h-full text-gray-600 hover:text-[#4B3BFF] hover:bg-gray-50 transition-colors duration-300 flex items-center justify-center"
                  >
                    <FontAwesomeIcon icon={faMinus} className="text-xs" />
                  </button>
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[1-4]"
                    value={numberOfImages}
                    onChange={(e) => {
                      const val = parseInt(e.target.value);
                      if (!isNaN(val) && val >= 1 && val <= 4) {
                        setNumberOfImages(val);
                      }
                    }}
                    className="w-8 text-center h-full text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#4B3BFF] focus:border-transparent appearance-none font-medium"
                    style={{ WebkitAppearance: "none", MozAppearance: "textfield" }}
                  />
                  <button
                    onClick={() => setNumberOfImages(Math.min(4, parseInt(numberOfImages) + 1))}
                    className="px-1 h-full text-gray-600 hover:text-purple-600 hover:bg-gray-50 transition-colors duration-300 flex items-center justify-center"
                  >
                    <FontAwesomeIcon icon={faPlus} className="text-xs" />
                  </button>
                </div>
                {/* <label className="block text-gray-700 font-semibold mb-2 text-xs tracking-wide text-center">no. of Img's</label> */}
              </div>

              {/* <button
                onClick={handleGenerate}
                disabled={createEstTime > 0}
                className={`flex-1 bg-gradient-to-r from-purple-500 to-indigo-500 text-white font-semibold py-2 lg:py-3 px-4 lg:px-6 rounded-lg shadow-lg transition-all duration-300 text-sm lg:text-base relative overflow-hidden ${createEstTime > 0
                  ? 'opacity-90 cursor-not-allowed'
                  : 'hover:shadow-xl hover:scale-[1.02] hover:from-purple-600 hover:to-indigo-600 active:scale-95'
                  }`}
              >
                {createEstTime > 0 && (
                  <div
                    className="absolute left-0 top-0 h-full bg-gradient-to-r from-purple-600 to-indigo-600 transition-all duration-300"
                    style={{ width: `${Math.max(0, Math.min(100, (createEstTime - progressCreate) / createEstTime * 100))}%`, opacity: 0.5 }}
                  ></div>
                )}
                <span className="relative z-10">
                  {createEstTime > 0
                    ? `Processing: ${Math.round((createEstTime - progressCreate) / createEstTime * 100)}%`
                    : "Generate"}
                </span>
              </button> */}
              <button
                onClick={handleGenerate}
                disabled={loadingCircle}
                className={`flex-1 bg-gradient-to-r from-purple-500 to-indigo-500 text-white font-semibold py-2 lg:py-3 px-4 lg:px-6 rounded-lg shadow-lg transition-all duration-300 text-sm lg:text-base relative overflow-hidden ${loadingCircle ? 'opacity-90 cursor-not-allowed' : 'hover:shadow-xl hover:scale-[1.02] hover:from-purple-600 hover:to-indigo-600 active:scale-95'}`}
              >
                <span className="relative z-10 flex items-center justify-center">
                  {loadingCircle ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Generating...
                    </>
                  ) : (
                    "Generate"
                  )}
                </span>
              </button>
            </div>
          </div>
        </div>

        {isProductModalOpen && (
          <div className="fixed inset-0 z-50 flex justify-center items-center">
            <div className="absolute inset-0 bg-black bg-opacity-90 backdrop-blur-2xl transition-all duration-500">
            </div>
            <div className="relative z-10 transform transition-all duration-500 ease-out"
              style={{
                opacity: isProductModalOpen ? 1 : 0,
                transform: isProductModalOpen ? 'scale(1)' : 'scale(0.95)',
                height: '80vh'
              }}
            >
              <button
                onClick={() => setIsProductModalOpen(false)}
                className="absolute -top-4 -right-4 w-9 h-9 bg-white rounded-full shadow-lg flex items-center justify-center group hover:bg-[#4B3BFF] transition-all duration-300 transform hover:scale-110 hover:rotate-90"
              >
                <svg
                  className="w-5 h-5 text-gray-600 group-hover:text-gray-600 transition-colors duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <ProductGallery
                setIsProductModalOpen={setIsProductModalOpen}
                selectedSubProduct={selectedProduct}
                handleProductSelect={handleProductSelect}
                setRefNum={setRefNum}
                setCreditsAvailable={setCreditsAvailable}
              />
            </div>
          </div>
        )}

        {isStyleModalOpen && (
          <div className="fixed inset-0 z-50 flex justify-center items-center">
            <div
              className="absolute inset-0 bg-black bg-opacity-90 backdrop-blur-2xl transition-all duration-500"
            ></div>
            <div className="relative z-10 transform transition-all duration-500 ease-out"
              style={{
                opacity: isStyleModalOpen ? 1 : 0,
                transform: isStyleModalOpen ? 'scale(1)' : 'scale(0.95)',
                height: '80vh'
              }}
            >
              <button
                onClick={() => setIsStyleModalOpen(false)}
                className="absolute -top-4 -right-4 w-9 h-9 bg-white rounded-full shadow-lg flex items-center justify-center group hover:bg-[#4B3BFF] transition-all duration-300 transform hover:scale-110 hover:rotate-90"
              >
                <svg
                  className="w-5 h-5 text-gray-600 group-hover:text-gray-600 transition-colors duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <StyleGallery
                onSelectStyle={handleStyleSelect}
                onClose={() => setIsStyleModalOpen(false)}
                setCreditsAvailable={setCreditsAvailable}
              />
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default CreateSidebar; 